import React from 'react';
import DatePickerInput from '@/components/General/inputs/DatePickerInput';

/**
 * Renders `date`, `time`, and legacy `datetime` schema fields. Reuses
 * `DatePickerInput`, selecting `mode` from the field type. Schema values are
 * stored as ISO strings; the picker emits Date objects which we convert back
 * to ISO on change. For `time` fields the date part of the stored ISO string
 * is ignored — only the time portion is displayed.
 *
 * Note: `DatePickerInput` does not expose a `disabled` prop; read-only/preview
 * mode is handled at the `FormView` level by not rendering interactive sections.
 */
const DateField = ({ field, value, onChange }) => {
    const config = field.config || {};
    const mode = field.type === 'time' ? 'time' : field.type === 'datetime' ? 'datetime' : 'date';

    return (
        <DatePickerInput
            title={field.label}
            value={value ? new Date(value) : null}
            onUpdate={(date) => onChange(date ? date.toISOString() : null)}
            mode={mode}
            minimumDate={config.min ? new Date(config.min) : null}
            maximumDate={config.max ? new Date(config.max) : null}
            required={field.required}
            helpText={field.description}
        />
    );
};

export default DateField;
